import { Col, Row } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/createStyles';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import useCustomTextFieldStyles from 'app/shareable/theme/useCustomTextFieldStyles';

const useClasses = createStyles(
  (theme: typeof defaultTheme) => ({
    container: {
      position: 'absolute',
      width: '100%',
      backgroundColor: theme.palette.background.white,
      padding: '1rem',
      left: 0,
      zIndex: 100,
      top: 'calc(100% + 4px)',
      borderRadius: '2px',
      boxShadow:
        '0px 2px 4px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    },
  }),
  { name: 'popupBox' }
);

interface ReservationPopupProps {
  title: string;
  subTitle: string;
}

export default function ReservationPopup({
  title,
  subTitle,
}: ReservationPopupProps) {
  const classes = useCustomTextFieldStyles();
  const containerClasses = useClasses();

  return (
    <div className={containerClasses.container}>
      <Col>
        <Row className="my-1">
          <TextField className={classes.h3}>{title}</TextField>
        </Row>
        <Row className="my-1">
          <TextField className={classes.smallText}>{subTitle}</TextField>
        </Row>
      </Col>
    </div>
  );
}
